import React, { useContext, useState } from "react";
import Snackbar, { LIFE_TIME } from "../components/snackbar";

const SnackbarContext = React.createContext();

export function useSnackbar() {
  return useContext(SnackbarContext);
}

export function SnackbarProvider({ children }) {
  const [snackbars, setSnackbars] = useState([]);
  
  // Generate unique ID for each snackbar
  const generateId = () => `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  
  const showSnackbar = (message, severity = "success", autoHideDuration = LIFE_TIME) => {
    const newSnackbar = {
      id: generateId(),
      message,
      severity,
      open: true,
      autoHideDuration,
    };
    
    setSnackbars(current => [...current, newSnackbar]);
  };
  
  const handleCloseSnackbar = (id) => {
    setSnackbars(current => 
      current.map(snackbar => 
        snackbar.id === id 
          ? { ...snackbar, open: false }
          : snackbar
      )
    );
    
    // Remove the snackbar after animation completes
    setTimeout(() => {
      setSnackbars(current => 
        current.filter(snackbar => snackbar.id !== id)
      );
    }, 300);
  };
  
  const value = {
    showSnackbar,
  };
  
  return (
    <SnackbarContext.Provider value={value}>
      {children}
      <div style={{ 
        position: 'fixed', 
        bottom: 20, 
        left: 20, 
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column-reverse',
        gap: '8px',
        pointerEvents: 'none' // Allow clicks to pass through container
      }}>
        {snackbars.map((snackbar) => (
          <div 
            key={snackbar.id}
            style={{ pointerEvents: 'auto' }} // Re-enable pointer events for individual snackbars
          >
            <Snackbar
              open={snackbar.open}
              severity={snackbar.severity}
              message={snackbar.message}
              autoHideDuration={snackbar.autoHideDuration}
              onClose={() => handleCloseSnackbar(snackbar.id)}
            />
          </div>
        ))}
      </div>
    </SnackbarContext.Provider>
  );
}